import api from './axios';

export const listLotes = () => api.get('/lotes/');
export const getLote = (id) => api.get(`/lotes/${id}`);
export const createLote = (data) => api.post('/lotes/', data);
export const updateLote = (id, data) => api.patch(`/lotes/${id}`, data);
